import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import Banner from '@/components/HomeBanner';
import ContactForm from '@/components/ContactForm';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';

export default function Execution({pageContent, siteSettings, dataPoints}:any) {
  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
      <main className="row contents-row">
        <Banner
          bannerHeading={pageContent[0].banner_heading} 
          bannerText={pageContent[0].banner_text} 
          bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()}
          featuredResearchPaper={pageContent[0].featured_research_paper[0]}
          bannerVideoText={pageContent[0].banner_video_text}
          bannerVideoThumbnail={urlFor(pageContent[0].banner_video_thumbnail).width(800).url()}
          bannerVideo={pageContent[0].banner_video}
        />
        <div className="col-12 contents-col">
          <div className="container">
            <div className="row title-row">
              <div className="col-12 title-col text-center title-font">
                <h2>The Line-of-Sight<span className="sm-placer">&#8480;</span></h2>
              </div>
            </div>
            {dataPoints.map((dataPoint:any) => (
              <>
              {dataPoint.sort_order % 2 == 0 ?
                <section className="row content-row">
                  <div className="col-12 order-2 col-sm-6 order-sm-1 content-row-text">
                    <div className="content">
                      <h4 className="title title-font">{dataPoint.heading}</h4>
                      <p className="subtitle subtitle-font">{dataPoint.sub_heading}</p>
                      <div className="regular-font text" dangerouslySetInnerHTML={{__html: toHTML(dataPoint.description)}}>
                        {/* */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 order-1 content-row-img col-sm-6 order-sm-2"><img src={urlFor(dataPoint.image).width(1000).url()} /></div>
                </section>
              :
                <section className="row content-row">
                  <div className="col-12 col-sm-6 content-row-img"><img src={urlFor(dataPoint.image).width(1000).url()} /></div>
                  <div className="col-12 col-sm-6 content-row-text">
                    <div className="content">
                      <h4 className="title title-font">{dataPoint.heading}</h4>
                      <p className="subtitle subtitle-font">{dataPoint.sub_heading}</p>
                      <div className="regular-font text" dangerouslySetInnerHTML={{__html: toHTML(dataPoint.description)}}>
                        {/* */}
                      </div>
                    </div>
                  </div>
                </section>
              }
              </>
            ))}
          </div>
        </div>
        <div className="col-12">
          <div className="row">
            <div className="col-12">
              <div className="container">
                <div className="row health-index-row">
                  <div className="col-12 health-index-image-col">
                    <img src={urlFor(pageContent[0].health_index_banner_image).width(1920).url()} />
                  </div>
                  <div className="col-12 col-sm-6 offset-sm-3 text-center health-index-text-col">
                    <h4 className="title title-font">{pageContent[0].health_index_heading}</h4>
                    <div className="regular-font text" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].health_index_description)}}>
                      {/* */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ContactForm adminEmails={siteSettings[0].admin_emails} />
      </main>
      <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(`*[_type == "homePage"] {
    title,
    banner_heading,
    banner_text,
    banner_image,
    banner_video_thumbnail,
    banner_video_text,
    banner_video,
    health_index_heading,
    health_index_description,
    health_index_banner_image,
    featured_research_paper[]->
  }`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  const dataPoints = await client.fetch(groq`*[_type == "homePageDataPoints"] | order(sort_order asc)`);
  return {
    props: {
      pageContent: pageContent,
      siteSettings: siteSettings,
      dataPoints: dataPoints
    }
  }
}
